import * as React from 'react';

import CheckBox from '@/components/elements/Form/CheckBox';
import { useUserContext } from '@/contexts/user';

import {
  CheckBoxContainer,
  CheckboxWrapper,
  Container,
  Icon,
  Title,
} from './style';

interface AutoChargeSelectProps {
  insufficientBalance: number;
  isAutoChargeByCash: boolean;
  isAutoChargeByOther: boolean;
  setIsAutoChargeByCash: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAutoChargeByOther: React.Dispatch<React.SetStateAction<boolean>>;
}

const AutoChargeSelect: React.FC<AutoChargeSelectProps> = ({
  insufficientBalance,
  isAutoChargeByCash,
  isAutoChargeByOther,
  setIsAutoChargeByCash,
  setIsAutoChargeByOther,
}) => {
  const { user } = useUserContext();

  return (
    <Container>
      <Icon />
      <Title>
        toreta+ 残高が
        <span data-testid="insufficient-balance">
          {insufficientBalance.toLocaleString()}円分
        </span>
        <br />
        不足しています
      </Title>
      <CheckBoxContainer>
        <CheckboxWrapper>
          <CheckBox
            htmlFor="cash"
            checked={isAutoChargeByCash}
            onChange={e => setIsAutoChargeByCash(e.target.checked)}
            disabled={insufficientBalance > user.wallet!.balance}
          >
            入金/払戻金 残高からチャージする
          </CheckBox>
        </CheckboxWrapper>
        <CheckboxWrapper>
          <CheckBox
            htmlFor="other"
            checked={isAutoChargeByOther}
            onChange={e => setIsAutoChargeByOther(e.target.checked)}
          >
            その他の方法でチャージする
          </CheckBox>
        </CheckboxWrapper>
      </CheckBoxContainer>
    </Container>
  );
};
export default AutoChargeSelect;
